import React, { Component } from "react";
import moment from "moment";
import CartHolder, { DrawerContent } from "./Styles/cartStyle";
import CartScreenRow from "./features/map_view/components/CartScreenRow";
import { Drawer, Button, Badge, Icon, Modal, Input, Form, message, Tooltip } from "antd";
import { withRouter } from "react-router";
import queryString from "query-string";
import { withTranslation } from 'react-i18next';
import NumberFormat from "./NumberFormat";
import UserRoleEnum from "../constants/UserRoleEnum";
import { hasAccessRole, getMinimunByCurrency, getUrl, SeparateNumberFormat, getDomain } from "../services/utils";
import { getTotalPice } from "../services/display";
import { isApprovedPaymentStatus } from "../services/campaignManager";
import Colors from "../themes/Colors";
import { AimSvg } from "../images/customIcons/AimSvg";
import ModalInfoNewViewComponent from "./ModalInfoNewViewComponent";
import VerifiedAgencyInfoModal from "./VerifiedAgencyInfoModal";
import { getTotalDisplays, getTotalCircuits, getTotalCircuitsDisplays, getTotalIndividualDisplays, getTotalMultipleFacesDisplays, getTotalMultipleFaces, getTotalMultipleFacesInCircuits, getTotalDisplaysWithMultipleFacesInCircuits } from "../services/cart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";
import ListPagination, { getPageItems, getLastPage } from "../newSrc/shared/components/ListPagination";

const CART_PAGE_SIZE = 100;

const AimIcon = (props) => <Icon component={AimSvg} {...props} />;

const DOMAIN_TO_BRAND = {
  grupoVia: 'grupovia',
  fenix: 'fenix',
  mediaShake: 'media_shake',
  smartFit: 'smart_fit',
  duoPrint: 'duoprint',
  territorioDigital: 'brick_thunder',
  movImagen: 'movimagen',
  yoda: 'yoda',
  hakMedia: 'hak_media',
  blaster: 'blaster',
  laMediatica: 'la_mediatica',
  dv360: 'dv360'
};

class CartComponent extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.screenListRef = React.createRef();
  }
  state = {
    visible: false,
    quote: "",
    companyData: "",
    profitQuote: "",
    nameQuote: "",
    displays: "",
    quoteModalVisible: false,
    errors: {},

    detailsDisplays: {
      totalDisplays: 0,
      totalCircuits: 0,
      totalCircuitsDisplays: 0,
      totalMultipleFacesInCircuits: 0,
      totalDisplaysWithMultipleFacesInCircuits: 0,
      totalIndividualDisplays: 0,
      totalMultipleFacesDisplays: 0,
      totalMultipleFaces: 0,
    },
    creatingQuote: false,
    currenciesModalVisible: false,
    isDevEnvironment: process.env.REACT_APP_API_ENDPOINT === "https://api.dev.publinet.io",
    isStagingEnvironment: process.env.REACT_APP_API_ENDPOINT === "https://api.staging.publinet.io",
    domain: getDomain(window.location.hostname),
    urlMap: process.env.REACT_APP_MAP,
    handlInfoNewViewOk: false,
    isUnverifiedMediaCompanyModalVisible: false,
    cartPage: 1,
  };

  componentDidMount = () => {
    const { cleanFilters } = this.props;
    cleanFilters();

    if (this.state.domain === "yoda") {
      this.setState({
        urlMap: process.env.REACT_APP_MAP_YODA
      })
    }

    if (this.props.onOpenDrawer) {
      const params = queryString.parse(this.props.history.location.search, {
        arrayFormat: "bracket",
      });
      if (params.is_quote) this.props.onOpenDrawer();
    }
  }

  isUnverifiedMediaCompanyTraditionalBlock = () => {
    const { user, cart, date_from, date_to, programmatic } = this.props;
    if (programmatic !== 'traditional') return false;
    if (!user || !user.company || user.company.type !== 'media' || user.company.is_verified) return false;
    const userCompanyId = user.company_id != null ? user.company_id : (user.company && user.company.id);
    const hasExternalScreens = cart && cart.some(display => {
      const displayCompanyId = display.company_id ? display.company_id : display.company && display.company.id;
      if (displayCompanyId == userCompanyId) return false;
      const displayHoldingId = display.holding_id ? display.holding_id : display.company && display.company.holding_id;
      const isHoldingDisplay = user.roles && user.roles.includes('holding-member') && user.holding && user.holding.id === displayHoldingId;
      return !isHoldingDisplay;
    });
    if (!hasExternalScreens) return false;
    return moment(date_to).diff(moment(date_from), 'days') >= 7;
  };

  changeCartPage = (page) => {
    this.setState({ cartPage: page });
    if (this.screenListRef.current) this.screenListRef.current.scrollTop = 0;
  };

  componentDidUpdate(prevProps) {

    if (prevProps.cart !== this.props.cart) {
      this.setState({
        detailsDisplays: {
          totalDisplays: getTotalDisplays(this.props.cart),
          totalCircuitsDisplays: getTotalCircuitsDisplays(this.props.cart),
          totalCircuits: getTotalCircuits(this.props.cart),
          totalMultipleFacesInCircuits: getTotalMultipleFacesInCircuits(this.props.cart),
          totalDisplaysWithMultipleFacesInCircuits: getTotalDisplaysWithMultipleFacesInCircuits(this.props.cart),
          totalIndividualDisplays: getTotalIndividualDisplays(this.props.cart),
          totalMultipleFacesDisplays: getTotalMultipleFacesDisplays(this.props.cart),
          totalMultipleFaces: getTotalMultipleFaces(this.props.cart)
        }
      })

      const lastPage = getLastPage(this.props.cart.length, CART_PAGE_SIZE);
      if (this.state.cartPage > lastPage) {
        this.setState({ cartPage: lastPage });
      }
    }
  }

  UNSAFE_componentWillMount() {
    const params = queryString.parse(this.props.history.location.search, {
      arrayFormat: "bracket",
    });
    if (params.is_quote) {
      this.setState({
        visible: true,
      });
    }
    if (params.quote_profit) {
      this.setState({
        quote: params.quote_profit,
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {

    const { dsp, getCurrencyExchangeRate, currencyExchangeRate, gettingCurrencyExchangeRate } = this.props;

    if (!!dsp && dsp.id && !gettingCurrencyExchangeRate && Array.isArray(currencyExchangeRate) && currencyExchangeRate.length === 0) {
      getCurrencyExchangeRate();
    }

    if (this.props.creatingQuote && !nextProps.creatingQuote) {
      if (nextProps.errors.length === 0) {
        let lenguageParse
        switch (nextProps.i18n.language) {
          case "es":
            lenguageParse = "esLA"
            break;
          case "es_ar":
            lenguageParse = "es"
            break;
          default:
            break;
        }
        const parameter = `lenguage=${lenguageParse || nextProps.i18n.language}&token=${nextProps.quote.token}&company=${this.state.companyData}`
        window.open(getUrl(window.location, "quote.html", parameter));
        this.handleQuoteCancel();
        message.success(this.props.t("Quote created successfully"));
        return;
      }
      message.error(
        this.props.t("An error occurred while trying to create a quote")
      );
    }


    // if (
    //   !editCampaignActive && this.props.cart.length === 0 &&
    //   nextProps.cart.length > 0 &&
    //   !isSuperUser &&
    //   (usersCanAccessNewView || companyCanAccessNewView) ){
    //     this.setState({
    //       handlInfoNewViewOk: true
    //     })
    //   }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  }

  handleQuoteCancel = (e) => {
    this.setState({
      quoteModalVisible: false,
    });
    Modal.destroyAll();
  };

  handleInfoNewViewCancel = (e) => {
    this.setState({
      handlInfoNewViewOk: false,
    });
  };

  showCurrenciesModal = (e) => {
    e.stopPropagation();
    this.setState({
      currenciesModalVisible: true,
    });
  };

  hideCurrenciesModal = () => {
    this.setState({
      currenciesModalVisible: false,
    });
  };

  showQuoteModal = () => {
    this.setState({
      quoteModalVisible: true,
    });
  };

  handleCreateQuote(companyData) {
    const errors = {};

    if (!this.state.nameQuote) {
      errors["nameQuote"] = this.props.t("Can not be blank");
    }

    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
      });

      return;
    }

    const quoteData = {
      name: this.state.nameQuote,
      brand: this.props.brand.id,
      client: this.props.client.id,
      properties: {
        budget:
          this.props.programmatic === "programmatic"
            ? parseFloat(this.props.amountBudget)
            : null,
        displays: this.state.displays,
        from_date: this.props.date_from,
        to_date: this.props.date_to,
        currency: this.props.currency,
        external_dsp_id: this.props.dsp ? this.props.dsp.id : null,
        invoice_issuing_country: this.props.invoiceIssuingCountry
      }
    }
    this.props.createQuote(quoteData)
  }

  showDrawer = () => {
    if (this.props.onOpenDrawer) return this.props.onOpenDrawer();
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    if (this.props.onCloseDrawer) return this.props.onCloseDrawer();
    this.setState({
      visible: false,
    });
  };

  checkMinimumBudget() {
    const { currency, campaignCurrency, editCampaignActive } = this.props

    const usedCurrency = editCampaignActive ? campaignCurrency : currency;

    const minimun = getMinimunByCurrency(usedCurrency)
    if (this.props.amountBudget == "" || parseInt(this.props.amountBudget) < minimun) {
      return true
    } else {
      return false
    }
  }

  exportXLS = () => {
    const { currency, campaignCurrency, editCampaignActive, client, invoiceIssuingCountry, dsp, campaignInvoiceIssuingCountry } = this.props

    const usedCurrency = editCampaignActive ? campaignCurrency : currency;
    const usedInvoiceIssuingCountry = editCampaignActive ? campaignInvoiceIssuingCountry : invoiceIssuingCountry;

    const displays = this.props.cart.map(display => ({
      id: display.id,
      price: this.props.programmatic !== 'traditional' ? display.smart_campaign_cpm / 1000 : display.price_per_day,
      currency: display.price_currency
    }));
    const params = {
      displays: displays,
      date_from: this.props.date_from,
      date_to: this.props.date_to,
      client_id: client.id,
      currency: usedCurrency,
      invoice_issuing_country: usedInvoiceIssuingCountry,
      external_dsp_id: dsp ? dsp.id : null,
      format: 'xls',
      _method: 'GET',
      smart_campaign: this.props.programmatic !== 'traditional' ? 1 : 0
    }
    this.props.getExcelDisplays(params);
  }

  setURLExportPNG = (e) => {
    const { urlMap, domain } = this.state;
    let displays = this.props.cart.map(function (display) {
      if (!display.count_secondary_displays) return display.id
      if (display.count_secondary_displays) return display.secondary_displays_ids
    });
    displays = displays.toString();

    let brand = DOMAIN_TO_BRAND[domain] || null;
    window.open(`${urlMap}/?id=${displays}${brand ? `&brand=${brand}` : ''}`, "_blank");
  }

  render() {
    const { t, user, cleanFilters, cleanArrayPolygon, date_from, date_to, loadingExcel, invoiceIssuingCountry, currencyExchangeRate, dsp, isGuaranteed, acceptedGuaranteedTerms } = this.props;
    const { errors } = this.state;
    let priceTraditional = 0
    if (this.props.programmatic != "programmatic") {
      priceTraditional = getTotalPice(this.props.cart, date_from, date_to)
    }

    const isProgrammatic = this.props.programmatic === "programmatic";
    const cpmCurrency = this.props.editCampaignActive ? this.props.campaignCurrency : this.props.currency;
    // No per-day audience field exists, so derive impacts/day from the total.
    const daysCount = Math.max(1, moment(date_to).diff(moment(date_from), "days") + 1);
    const impactsPerDay = this.props.audience.total_impacts
      ? Math.round(this.props.audience.total_impacts / daysCount)
      : 0;

    // Controlled by parent when the drawer callbacks are provided, else local.
    const drawerOpen = this.props.onOpenDrawer
      ? this.props.drawerVisible
      : this.state.visible;
    // In table view the compact summary button replaces this floating button.
    const showFloatingButton =
      this.props.cart.length > 0 && this.props.viewMode !== "table";

    const isProgrammaticProviders = this.props.user && this.props.user.holding && this.props.user.holding && this.props.user.holding.id === 50;

    const cmpiValues = this.props.cart.map(item => item.cpmi).filter(v => typeof v === 'number');
    const minCpmi = cmpiValues.length ? Math.min(...cmpiValues) : null;
    const maxCpmi = cmpiValues.length ? Math.max(...cmpiValues) : null;


    return (
      <CartHolder>
        <Button
          className={showFloatingButton ? "cartButton" : "cartButtonHidden"}
          type="primary"
          onClick={this.showDrawer}
        >
          <span style={{ marginBottom: "8px" }}>{t("Screen selection")}</span>
          <br />
          {this.props.cart.length > 0 ? (
            <NumberFormat
              value={
                this.props.programmatic === "programmatic"
                  ? this.props.amountBudget
                  : priceTraditional
              }
              currency={this.props.cart[0].price_currency}
            />
          ) : null}
          <Badge
            count={this.props.cart.length}
            style={{
              backgroundColor: Colors.atention,
              left: "22px",
              bottom: "2px",
            }}
          >
            <Icon
              style={{ fontSize: "22px", marginLeft: "15px" }}
              type="desktop"
              theme="outlined"
            />
          </Badge>
          {currencyExchangeRate && currencyExchangeRate.currency != "USD" && !!dsp && dsp.id && <>
            <br />
            <hr style={{ borderTop: `1px solid ${Colors.white}`, width: "100%", margin: "4px" }} />
            <Button onClick={(e) => { this.showCurrenciesModal(e); }} block size="small" className="currencyExchangeButton">
              {t("See currency exchange rate")}
            </Button>
          </>}
        </Button>

        <Drawer
          placement="right"
          closable={false}
          onClose={this.onClose}
          visible={this.props.cart.length > 0 ? drawerOpen : false}
          width={window.innerWidth < 768 ? "100%" : 880}
          bodyStyle={{ padding: "0", height: "100%" }}
        >
          <DrawerContent>
            <div className="cartHeader">
              <span className="cartHeaderTitle">{t("Screen selection")}</span>
              <Icon type="close" className="cartClose" onClick={this.onClose} />
            </div>

            <div className="cartBody">
              <div className="cartListColumn">
                <div className="cartScreenList" ref={this.screenListRef}>
                  {this.props.cart.length > 0 ? (
                    getPageItems(this.props.cart, this.state.cartPage, CART_PAGE_SIZE).map((display) => (
                      <CartScreenRow
                        key={display.id}
                        display={display}
                        programmatic={this.props.programmatic}
                        onRemove={this.props.removeDisplayFromCart}
                        cart={this.props.cart}
                        listBundle={this.props.listBundle}
                        removeBundlesFromCart={this.props.removeBundlesFromCart}
                        editCampaignActive={this.props.editCampaignActive}
                        editCampaign={this.props.editCampaign}
                      />
                    ))
                  ) : (
                    <div className="cartEmpty">
                      {t("There are no more screens selected")}
                    </div>
                  )}
                </div>
                <ListPagination
                  total={this.props.cart.length}
                  pageSize={CART_PAGE_SIZE}
                  current={this.state.cartPage}
                  onChange={this.changeCartPage}
                  size="small"
                  labelKey="Showing {{shown}} of {{total}} screens"
                />
              </div>

              <div className="cartInfoColumn">
              <div className="budgetCard">
                <div className="budgetCardLabel">
                  {isProgrammatic
                    ? t("Estimated budget")
                    : t("Total campaign price")}
                </div>
                <div className="budgetCardValue">
                  {this.props.cart[0] ? (
                    <NumberFormat
                      tax={invoiceIssuingCountry != "F"}
                      value={isProgrammatic ? this.props.amountBudget : priceTraditional}
                      currency={this.props.cart[0].price_currency}
                    />
                  ) : null}
                </div>
                {isProgrammatic && minCpmi != null && maxCpmi != null ? (
                  <div className="budgetCardCpm">
                    {t("CPM")}{" "}
                    {minCpmi === maxCpmi ? (
                      <NumberFormat tax={false} value={minCpmi} currency={cpmCurrency} />
                    ) : (
                      <>
                        <NumberFormat tax={false} value={minCpmi} currency={cpmCurrency} />
                        {" – "}
                        <NumberFormat tax={false} value={maxCpmi} currency={cpmCurrency} />
                      </>
                    )}
                  </div>
                ) : null}
                {isProgrammatic && this.checkMinimumBudget() ? (
                  <div className="budgetMinWarning">
                    {t("The minimum purchase price is not reached")}{" "}
                    <NumberFormat
                      tax={false}
                      value={getMinimunByCurrency(this.props.currency)}
                      currency={this.props.currency}
                    />
                  </div>
                ) : null}
              </div>

              {/* Moved out of the drawer header so the count sits with the
                  screen breakdown it describes. */}
              <div className="selectedScreensCount">
                <span className="count">{this.props.cart.length}</span>{" "}
                {t("screens selected")}
              </div>

              <div className="screensSummary">
                <div className="screensSummaryItem">
                  <Icon type="desktop" theme="outlined" />
                  <span className="value">
                    {this.state.detailsDisplays.totalIndividualDisplays}
                  </span>
                  <span className="label">{t("individual screens")}</span>
                </div>
                <Tooltip
                  placement="top"
                  title={
                    <div>
                      <div>
                        {this.state.detailsDisplays.totalCircuitsDisplays}{" "}
                        {t("screens")} {t("in total")}
                      </div>
                      {this.state.detailsDisplays.totalDisplaysWithMultipleFacesInCircuits > 0 ? (
                        <div style={{ marginTop: "4px" }}>
                          <div>
                            {this.state.detailsDisplays.totalCircuitsDisplays -
                              this.state.detailsDisplays.totalDisplaysWithMultipleFacesInCircuits}{" "}
                            {t("individual screens")}
                          </div>
                          <div>
                            {this.state.detailsDisplays.totalDisplaysWithMultipleFacesInCircuits}{" "}
                            {t("multiple face screens")}
                            {this.state.detailsDisplays.totalMultipleFacesInCircuits > 0
                              ? ` (${this.state.detailsDisplays.totalMultipleFacesInCircuits} ${t("faces")} ${t("in total")})`
                              : ""}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  }
                >
                  <div className="screensSummaryItem">
                    <Icon type="deployment-unit" theme="outlined" />
                    <span className="value">
                      {this.state.detailsDisplays.totalCircuits}
                    </span>
                    <span className="label">{t("Circuits")}</span>
                  </div>
                </Tooltip>
                <Tooltip
                  placement="top"
                  title={`${this.state.detailsDisplays.totalMultipleFaces} ${t("faces")} ${t("in total")}`}
                >
                  <div className="screensSummaryItem">
                    <FontAwesomeIcon icon={faClone} />
                    <span className="value">
                      {this.state.detailsDisplays.totalMultipleFacesDisplays}
                    </span>
                    <span className="label">{t("multiple face screens")}</span>
                  </div>
                </Tooltip>
              </div>

              {this.props.audience.total_audience > 0 ? (
                <div className="audienceCard">
                  <div className="audienceCardTitle">
                    <Icon type="usergroup-add" theme="outlined" />
                    {t("Audience")}
                  </div>
                  <div className="audienceStatRow">
                    <div className="audienceStat">
                      <div className="audienceStatValue">
                        {SeparateNumberFormat(this.props.audience.total_audience)}
                      </div>
                      <div className="audienceStatLabel">
                        <Icon type="team" theme="outlined" style={{color: Colors.green}} />
                        {t("Max. available imp.")}
                      </div>
                    </div>
                    <div className="audienceStat">
                      <div className="audienceStatValue">
                        {SeparateNumberFormat(this.props.audience.total_impacts)}
                      </div>
                      <div className="audienceStatLabel">
                        <AimIcon style={{color: Colors.atention}} />
                        {t("Impacts")}
                        <Tooltip
                          placement="left"
                          title={t(
                            "Estimated impressions based on campaign settings. You can add campaign days( in traditional) or increase the budget (in programmatic)."
                          )}
                        >
                          <Icon type="info-circle" theme="outlined" />
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                  <div className="audienceBreakdown">
                    {/* <div className="audienceBreakdownItem">
                      <Icon type="deployment-unit" theme="outlined" />
                      <span className="value">
                        {this.state.detailsDisplays.totalCircuits}
                      </span>
                      <span className="label">{t("Circuits")}</span>
                    </div> */}
                    <div className="audienceBreakdownItem">
                      <Icon type="desktop" theme="outlined" />
                      <span className="value">
                        {this.state.detailsDisplays.totalDisplays}
                      </span>
                      <span className="label">
                        {t("Faces")}
                        <Tooltip
                          placement="top"
                          title={
                            <div>
                              <div style={{ fontWeight: 600, marginBottom: "4px" }}>
                                {t("Total faces")}
                              </div>
                              <ul style={{ margin: 0, paddingLeft: "16px" }}>
                                <li>{t("individual screens")}</li>
                                <li>{t("Faces of multiple-face screens")}</li>
                                <li>{t("Faces of the screens within circuits")}</li>
                              </ul>
                            </div>
                          }
                        >
                          <Icon type="info-circle" theme="outlined" />
                        </Tooltip>
                      </span>
                    </div>
                    <div className="audienceBreakdownItem">
                      <Icon type="eye" theme="outlined" />
                      <span className="value">
                        {SeparateNumberFormat(impactsPerDay)}
                      </span>
                      <span className="label">{t("Imp./day")}</span>
                    </div>
                  </div>
                </div>
              ) : null}

              <div className="cartActions">
                  <Button
                    style={{ textTransform: "capitalize" }}
                    type="primary"
                  disabled={
                    (this.props.programmatic === "programmatic" && this.checkMinimumBudget()) ||
                    (this.props.programmatic != "programmatic" && priceTraditional <= 0) ||
                    isProgrammaticProviders ||
                    (isGuaranteed && !acceptedGuaranteedTerms)
                  }
                  onClick={() => {
                    cleanFilters();
                    if (!user) {
                      this.props.setShouldPromptLogin(true, null);
                      return;
                    }
                    if (this.isUnverifiedMediaCompanyTraditionalBlock()) {
                      this.setState({ isUnverifiedMediaCompanyModalVisible: true });
                      return;
                    }
                    // Users whose ONLY role is advertiser go to the old view.
                    const isOnlyAdvertiser =
                      user.roles &&
                      user.roles.length === 1 &&
                      user.roles.includes(UserRoleEnum.advertiser);
                    if (isOnlyAdvertiser) {
                      this.props.history.push("/videoUpload");
                      return;
                    }
                    if (
                      hasAccessRole(user.roles, [
                        UserRoleEnum.agencyMember,
                        UserRoleEnum.companyMember,
                      ])
                    ) {
                      if (this.props.client.id && this.props.brand.id) {
                        this.props.history.push({
                          pathname: "/campaignManager",
                          state: { from: "map" },
                        });
                      } else {
                        message.error(
                          this.props.t(
                            "You must select a customer and brand before starting a campaign launch"
                          ),
                          10
                        );
                      }
                    } else {
                      this.props.history.push("/campaignManager");
                    }
                  }}
                >
                  {t("continue")} <Icon type="right" theme="outlined" />
                </Button>

                {user &&
                hasAccessRole(user.roles, [
                  UserRoleEnum.agencyMember,
                  UserRoleEnum.companyMember,
                ]) ? (
                  <>
                    <Button
                      onClick={() => {
                        if (this.props.client.id && this.props.brand.id) {
                          const displaysArray = [];
                          this.props.cart.map((display) =>
                            displaysArray.push(display.id)
                          );
                          const companyData = btoa(
                            JSON.stringify(this.props.user.company)
                          );
                          this.setState({
                            displays: displaysArray.toString(),
                            companyData: companyData,
                          });
                          this.showQuoteModal();
                        } else {
                          message.error(
                            this.props.t(
                              "You must select a customer and brand before creating a quote"
                            ),
                            10
                          );
                        }
                      }}
                    >
                      <Icon type="solution" theme="outlined" /> {t("Save quote")}
                    </Button>
                    <Button
                      onClick={this.exportXLS}
                      disabled={loadingExcel}
                    >
                      <Icon type="download" theme="outlined" /> {t("Export Excel")}
                    </Button>
                    <Button className="outlineGrayButton" onClick={this.setURLExportPNG}>
                      <Icon type="export" theme="outlined" /> {t("Export map")}
                    </Button>
                  </>
                ) : null}

                {!(this.props.editCampaignActive && isApprovedPaymentStatus(this.props.editCampaign)) && (
                  <Button
                    className="deleteSelectionButton"
                    onClick={() => {
                      this.props.cleanAudience();
                      this.props.removeDisplaysCart();
                      cleanArrayPolygon();
                      cleanFilters();
                    }}
                  >
                    <Icon type="delete" theme="outlined" /> {t("Delete selection")}
                  </Button>
                )}
              </div>
              </div>
            </div>
          </DrawerContent>
        </Drawer>
        <Modal
          visible={this.state.quoteModalVisible}
          onOk={this.handleLoginOk}
          onCancel={this.handleQuoteCancel}
          footer={null}
        >
          <div className="modalQuote">
            <h2>{t("Save Quote")}</h2>
          </div>
          <div className="modalContent">
            <p className="modalContentText">{t("The list of selected screens will be saved. You will be able to resume the campaign later from the My Quotes section.")}</p>
          </div>
          <div className="modalContent">
            <Form.Item
              validateStatus={!!errors["nameQuote"] ? "error" : ""}
              help={errors["nameQuote"]}
            >
              <Input
                autoFocus
                name="nameQuote"
                className="modalInput"
                placeholder={t("Name")}
                value={this.state.nameQuote}
                onChange={this.handleInputChange}
                prefix={<Icon type="file-text" className="inputIcon" />}
                onPressEnter={() => this.handleCreateQuote()}
                autoComplete="off"
              />
            </Form.Item>
            <Button
              className="modalButton"
              onClick={() => this.handleCreateQuote()}
              loading={this.props.creatingQuote}
            >
              {t("Save")}
            </Button>
          </div>
        </Modal>
        <ModalInfoNewViewComponent
          onCancel={this.handleInfoNewViewCancel}
          visible={this.state.handlInfoNewViewOk}
          showMainModal={true}
        />
        <Modal
          visible={this.state.currenciesModalVisible && currencyExchangeRate}
          onCancel={this.hideCurrenciesModal}
          footer={null}
          title={t("Currency exchange rate")}
        >
          <div className="modalContent">
            <span style={{ fontSize: "16px" }}>
              <NumberFormat
                tax={false}
                value={1}
                currency={currencyExchangeRate.base}
              />
              =&nbsp;
              <NumberFormat
                tax={false}
                value={currencyExchangeRate.rate}
                currency={currencyExchangeRate.currency}
              />
            </span>
            <br />
            <span>
              {t("Conversion generated at 11AM (Argentina time) today")}
            </span>
          </div>
        </Modal>
        <VerifiedAgencyInfoModal
          isVisible={this.state.isUnverifiedMediaCompanyModalVisible}
          hide={() => this.setState({ isUnverifiedMediaCompanyModalVisible: false })}
          message={this.props.t('Unverified media company traditional limit')}
        />
      </CartHolder>
    );
  }
}

const Extended = withTranslation()(CartComponent);
Extended.static = CartComponent.static;

export default withRouter(Extended);
